const autofocus = {
    inserted(el, { value }) {
        if (value) {
            el.focus();
        }
    },
};
export default autofocus;
